<template>
  <div :class="$style['pt-holiday-form']">
    <pt-form-item label="节假日类型：" :required="true" :labelWidth="labelWidth">
      <wt-selector :options="options" v-model="currentData.holidayType" data-vv-as="节假日类型" v-validate="'required'" placeholder="请选择类型"></wt-selector>
    </pt-form-item>
    <pt-form-item label="节假日名称：" :required="true" :labelWidth="labelWidth">
      <el-input data-vv-as="节假日名称" v-validate="'required'" v-model="currentData.name" placeholder="请输入节假日名称"></el-input>
    </pt-form-item>
    <pt-form-item label="日期：" :required="true" :labelWidth="labelWidth">
      <el-date-picker value-format="yyyy-MM-dd" data-vv-as="日期" v-validate="'required'" type="dates"  v-model="currentData.dates" placeholder="选择一个或多个日期">
      </el-date-picker>
    </pt-form-item>

  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { holidayType } from 'json/lab-order'
// 组件class前缀
const prefixCls = 'pt-holiday-form'

export default {
  name: 'pt-holiday-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      labelWidth: '100px',
      options: holidayType,
      currentData: this.value ? this.value : {
        name: '',
        dates: [],
        type: ''
      }
    }
  },
  watch: {
    value (val) {
      this.currentData = val
    },
    currentData (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-holiday-form {

    :global {

      .el-input,
      .el-input__inner {
        max-width: 2.8rem;
      }

      .el-input--suffix .el-input__inner {
        min-width: 2.8rem;
      }

      .el-upload--picture-card,
      .el-upload-list--picture-card .el-upload-list__item {
        width: 117px;
        height: 155px;
      }

      el-textarea,
      .el-textarea__inner {
        width: 500px;
      }

      .wt-upload-file {
        line-height: 0;
        margin-top: 10px;
      }
    }

    .upload-file-text {
      line-height: 155px;
    }
  }
</style>
